import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { connect } from 'react-redux';
import Routes from './Routes';
import './less/app.less';

const App = () => {

  useEffect(() => {
    const el = document.querySelector('.loader-container');
    if (el) { el.remove(); }
  }, []);

  return (
    <Router>
      <Routes />
    </Router>
  );
};

export default connect(null, null)(App);
